/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreditRequestLogDto } from '../../models/credit-request-log-dto';
import { UpdateCreditRequestLogDto } from '../../models/update-credit-request-log-dto';

export interface CreditRequestLogControllerUpdate$Params {
  id: string;
      body: UpdateCreditRequestLogDto
}

export function creditRequestLogControllerUpdate(http: HttpClient, rootUrl: string, params: CreditRequestLogControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<CreditRequestLogDto>> {
  const rb = new RequestBuilder(rootUrl, creditRequestLogControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreditRequestLogDto>;
    })
  );
}

creditRequestLogControllerUpdate.PATH = '/api/creditRequestLog/{id}';
